const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/DatesRangeFilter.vue"),
    props: {
      filterName: "created_at",
      label: "Date",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/SelectFilter.vue"),
    props: {
      filterName: "operation_eq",
      label: "Operation",
      items: [
        "ThompsonSearch",
        "ThompsonAvailability",
        "ThompsonBook",
        "ThompsonCancel",
        "ThompsonAmend",
        "ThompsonStatus",
      ],
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/SelectFilter.vue"),
    props: {
      filterName: "http_method_eq",
      label: "HTTP Method",
      items: ["GET", "POST", "POST_XML"],
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter.vue"),
    props: {
      filterName: "success_eq",
      label: "Status",
      trueLabel: "Success",
      falseLabel: "Failed",
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter.vue"),
    props: {
      filterName: "reference_contains",
      label: "Reference",
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/admin/logs/third-party-api-logs-filters.js